var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPopupVectorOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5344 3.28915L10.5339 3.28818C9.71015 1.62224 8.46306 0.5 7 0.500001C5.53694 0.500001 4.28985 1.62224 3.46608 3.28818L3.46561 3.28915L0.899946 8.50618C0.886574 8.52932 0.87782 8.53802 0.877898 8.5381C0.877922 8.53812 0.878775 8.53734 0.880577 8.53591C0.884195 8.53305 0.891512 8.5278 0.90274 8.52212L1 8.56995L1 9L1 9.5L13 9.5L13.1459 8.52175C13.1546 8.52441 13.1606 8.52667 13.1636 8.52783L13.1672 8.52926L13.1683 8.52975C13.1683 8.52975 13.1681 8.52964 13.1675 8.52938L13.1652 8.52825L13.1573 8.52407C13.1432 8.51637 13.1248 8.50505 13.1065 8.49194C13.0984 8.48615 13.0912 8.48064 13.085 8.47566L10.5344 3.28915ZM1 8.55122L0.927705 8.51171C0.948296 8.50474 0.972939 8.5 1 8.5L1 8.55122Z",
    fill: "white",
    stroke: "#A4A4A4"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPopupVectorOutline);
export default __webpack_public_path__ + "static/media/icon-popup-vector-outline.c6de8ab16d6357e4df5dbd556c61c627.svg";
export { ForwardRef as ReactComponent };